import { Field } from 'formik'
import React from 'react'

import { TinyMCE } from '@components/adapters/inputs/TinyMCE'
import { Input } from '@fourthwall/components'

import * as S from './styled'

type ProductSectionProps = {
  index: number
}

export const ProductSection = ({ index }: ProductSectionProps) => (
  <>
    <S.TitleWrapper>
      <Field name={`additionalSections[${index}].title`} component={Input} label="Title" />
    </S.TitleWrapper>
    <Field
      name={`additionalSections[${index}].bodyHtml`}
      component={TinyMCE}
      buttons={{ code: true }}
    />
  </>
)
